// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .footerTastiAzione {
  z-index: 20;
  --ion-grid-padding: 0;
  background-color: var(--ion-color-light-tint);
  width: 100%;
  position: fixed;
  bottom: 0;
  min-height: 5em;
  justify-content: center;
}
:host .footerTastiAzione .separatore {
  background-color: var(--ion-color-light-shade);
  height: 0.1em;
}`, "",{"version":3,"sources":["webpack://./src/app/common/sharedComponents/bottom-footer-buttons/bottom-footer-buttons.component.scss"],"names":[],"mappings":"AACE;EACE,WAAA;EACA,qBAAA;EACA,6CAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;EACA,uBAAA;AAAJ;AAEI;EACE,8CAAA;EACA,aAAA;AAAN","sourcesContent":[":host {\r\n  .footerTastiAzione {\r\n    z-index: 20; // mi posiziono piu' in alto della pagina\r\n    --ion-grid-padding: 0;\r\n    background-color: var(--ion-color-light-tint);\r\n    width: 100%;\r\n    position: fixed;\r\n    bottom: 0;\r\n    min-height: 5em; // spazio aggiuntivo che mitiga lo scostamento dovuto al plugin della tastiera\r\n    justify-content: center;\r\n\r\n    .separatore {\r\n      background-color: var(--ion-color-light-shade);\r\n      height: 0.1em;\r\n\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
